<template>
  <div class="text-center">
    <button @click="openDialog">{{ $t('recoverFP.button.forgotPassword') }}</button>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" persistent>
      <v-card class="container justify-content-between align-items-center" >
        <button class="close-button" @click="closeDialog">
          <span class="small-x">X</span>
        </button>
        <img src="https://ibliss-icons-dev.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"/>
        <h2 color="primary" style="text-align: center;">{{ $t('login.passChange.label.title') }}</h2>
        <h5 style=" color: black; text-align: center;">{{ $t('recoverFP.label.subtitle1') }} <br>{{ $t('label.email.text') }}</h5>
        <v-col cols="12">
          <v-container>
            <v-col cols="12" md="12" sm="12">
              <v-text-field id="correo" :label="'*'+$t('label.email.title')" :placeholder="$t('label.email.text')"
                append-icon="mdi mdi-account-outline" outlined color=primary v-model="formData.correo"
                :rules="emailRules" :counter="200" :maxlength="200" required></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn large block rounded color="primary" class="mb-4" style="color: white; border-radius: 50px;"
              :disabled="!isEmailValid" @click="recoverForgottenPassword">
              {{ $t('button.send') }}
            </v-btn>
        </v-container>
      </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import {
  RECOVER_FORGOTTEN_PASSWORD_M,
  ACTION_GET_RECOVERFORGOTTENPASSWORD
} from "@/views/recover_forgotten_password/store/types/types.js";
import actions_token from "@/plugins/http/actions_token/actions_token.js";
import EventBus from '@/utils/event_bus.js';
import i18n from '@/plugins/i18n';
import { mapActions } from 'vuex';
import Swal from "sweetalert2";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export default {
  name: "formValidationEmail",

  data() {
    return {
      dialog: false,
      formData: {
        correo: ''
      },

      emailRules: [
        v => !!v || this.$t('label.email.required'),
        v => emailRegex.test(v) || this.$t('label.email.invalid')
      ],
      showErrorMessages: false,
    }

  },

  computed: {

    isEmailValid() {
      return this.formData.correo && emailRegex.test(this.formData.correo) && this.formData.correo.length <= 200;
    },

  },

  methods: {
    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      EventBus.$emit('close-dialog');
      window.location.reload();
    },

    ...mapActions({
      getRecoverForgottenPass: `${RECOVER_FORGOTTEN_PASSWORD_M}${ACTION_GET_RECOVERFORGOTTENPASSWORD}`,
    }),

    async recoverForgottenPassword() {
      const errors = this.validateForm();

      if (Object.keys(errors).length > 0) {
        const errorMessages = Object.values(errors).join('<br>');
        return Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.plural.title'),
          html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
          confirmButtonColor: '#6E17A5'
        });
      } else {
        await actions_token._createdToken(this.formData);
        const token = JSON.parse(sessionStorage.getItem('token'));

        if (token) {
          this.getRecoverForgottenPass(this.formData.correo).catch(() => {
            sessionStorage.clear();
          });
        }
      }
      this.dialog = false;
    },

    validateForm() {

      this.showErrorMessages = true;
      const errors = {};

      if (!this.formData.correo || !emailRegex.test(this.formData.correo) || this.formData.correo.length > 200) {
        errors.correo = this.$t('label.email.title');
      }

      return errors;
    },
  }
}
</script>

<style lang="css" scoped>
body {
  font-family: 'Nunito Sans', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Amsi Pro', sans-serif;
}

img {
  width: 30vh;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6E17A5;
}

.small-x {
  font-size: smaller;
}


@media screen and (max-width: 900px) {
  .row {
    padding-top: 0vh;
  }
}
</style>